/**
 * 可撤销命令基类，子类实现具体的执行与撤销逻辑。
 */
export abstract class Command {
  /** 执行该操作 */
  abstract execute(): void

  /** 撤销该操作 */
  abstract undo(): void

  /** 重做该操作，默认等价于再次调用 execute */
  redo() {
    this.execute()
  }

  // 分步撤销操作（可选），用于复杂操作的逐步撤销
  undoStep?(): void

  canUndoStep?(): boolean

  /**
   * 判断命令当前是否可提交入历史栈。
   *
   * @returns 可提交返回 true，否则返回 false
   */
  canCommit(): boolean {
    return true
  }
}
